export const getFrecuencias = () => {
  return frecu;
};

export const convertFrecuencia = (dias) => {
  const valorInfo = frecu.find((x) => x.valor == dias);
  return valorInfo;
};

const frecu = [
  { id: 1, name: "Semanal", valor: 7 },
  { id: 2, name: "Mensual", valor: 30 },
  { id: 3, name: "Semestral", valor: 180 },
  { id: 4, name: "Anual", valor: 365 },
];
